import i18n from "@/i18n";

export const tr = (key: string, options?: Record<string, unknown>): string =>
  String(i18n.t(key, options));

export function defineI18nGetters<T extends object>(
  obj: T,
  keys: Record<string, string>,
): T {
  for (const [prop, key] of Object.entries(keys)) {
    Object.defineProperty(obj, prop, {
      get: () => tr(key),
      enumerable: true,
      configurable: true,
    });
  }
  return obj;
}

export const lazyLabels = (
  prefix: string,
  values: readonly string[],
): Record<string, string> =>
  defineI18nGetters(
    {} as Record<string, string>,
    Object.fromEntries(values.map((v) => [v, `${prefix}.${v}`])),
  );
